export default __webpack_public_path__ + "static/media/c3a9a4de233a1a1769d318f344933200.svg";